import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-dirty-check-modal',
  templateUrl: './dirty-check-modal.component.html',
  styleUrls: ['./dirty-check-modal.component.scss'],
  imports: [TranslatePipe, NgbTooltip]
})
export class DirtyCheckModalComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}
}
